import React from "react";
import { View, Text, TouchableOpacity, ScrollView } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import ImageComponent from "../../ImageComponent";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../../screens/Utility/AppScreens";

interface Viewer {
  userID: string;
  profilePicture?: string;
}

interface SignedUpViewersProps {
  viewers: Viewer[];
  totalCount: number;
  isLoading?: boolean;
  navigation: any;
}

const SignedUpViewers: React.FC<SignedUpViewersProps> = ({
  viewers,
  totalCount,
  isLoading = false,
  navigation,
}) => {
  if (isLoading) {
    return (
      <View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <Text
            style={[AppFontStyle.BOLD_ANYBODY_18, { color: "#FFFFFF" }]}
          >
            Signed up Viewers
          </Text>
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_32,
              { color: "#FFFFFF", fontSize: 24 },
            ]}
          >
            ...
          </Text>
        </View>
        <LinearGradient
          colors={["rgba(25, 33, 44, 0.5)", "rgba(17, 24, 39, 0.50)"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={{
            minHeight: 200,
            borderRadius: 8,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              color: "rgba(255, 255, 255, 0.60)",
              fontSize: 14,
            }}
          >
            Loading...
          </Text>
        </LinearGradient>
      </View>
    );
  }

  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <Text style={[AppFontStyle.BOLD_ANYBODY_18, { color: "#FFFFFF" }]}>
          Signed up Viewers
        </Text>
        <Text
          style={[
            AppFontStyle.BOLD_ANYBODY_32,
            { color: "#FFFFFF", fontSize: 24 },
          ]}
        >
          {totalCount}
        </Text>
      </View>

      <LinearGradient
        colors={["rgba(25, 33, 44, 0.5)", "rgba(17, 24, 39, 0.50)"]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={{ width: "100%", borderRadius: 8, overflow: "hidden" }}
      >
        <View style={{ height: 175 }}>
          {viewers.length > 0 ? (
            <ScrollView
              style={{ flex: 1 }}
              contentContainerStyle={{
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 8,
                padding: 8,
              }}
              showsVerticalScrollIndicator={false}
            >
              {viewers.map((item, index) => (
                <TouchableOpacity
                  key={index}
                  style={{
                    alignItems: "center",
                    marginVertical: 10,
                    padding: 12,
                    gap: 10,
                  }}
                  onPress={() => {
                    navigateToScreen(navigation, AppScreens.UserProfile, {
                      username: item?.userID,
                    });
                  }}
                >
                  <View
                    style={{
                      backgroundColor: AppColors.lightPurple_604e74,
                      borderRadius: 50,
                      width: 38.156,
                      height: 38.156,
                      overflow: "hidden",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {item.profilePicture ? (
                      <ImageComponent
                        url={item.profilePicture}
                        style={{
                          width: 38.156,
                          height: 38.156,
                          resizeMode: "cover",
                        }}
                      />
                    ) : (
                      <View
                        style={{
                          width: 38.156,
                          height: 38.156,
                          backgroundColor: AppColors.lightPurple_604e74,
                        }}
                      />
                    )}
                  </View>
                  <Text
                    style={{
                      color: "#C4C4C4",
                      fontSize: 12,
                      fontWeight: "700",
                      lineHeight: 13.86,
                      textAlign: "center",
                      marginVertical: 5,
                    }}
                  >
                    {item?.userID}
                  </Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
          ) : (
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  color: "rgba(255, 255, 255, 0.60)",
                  fontSize: 14,
                  textAlign: "center",
                }}
              >
                No viewers signed up yet
              </Text>
            </View>
          )}
        </View>
      </LinearGradient>
    </View>
  );
};

export default SignedUpViewers;
